import { createSlice } from "@reduxjs/toolkit";
import { attendanceStatusList,createStatus,updateStatus,deleteStatus,getAttendanceStatusById } from "./StatusActions";

const initialState = {
  attendanceStatus: [],
   meta: {
        totalRecords:0,
        totalPages:0,
        currentPage:1,
        pageSize:5,
    },
  loading: false,
  error: null,
  selectStatus: null,
};

const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(attendanceStatusList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(attendanceStatusList.fulfilled, (state, action) => {
         console.log("LIST PAYLOAD:", action.payload);
        state.loading = false;
        // state.attendanceStatus = action.payload.data.message;

         const paged = action.payload?.data || {};

            const attendanceStatus = paged?.message || [];

            state.attendanceStatus = Array.isArray(attendanceStatus) ? attendanceStatus: [];

            state.meta = {
                totalRecords: paged?.TotalRecords ?? 0,
                totalPages: paged?.TotalPages ?? 0,
                currentPage: paged?.CurrentPage ?? 0,
                pageSize: paged?.PageSize ?? 0,
            }
      })

      .addCase(attendanceStatusList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       .addCase(createStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(createStatus.fulfilled, (state, action) => {
        state.loading = false;
        // state.attendanceStatus = action.payload.data;
      })

      .addCase(createStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }) 
      .addCase(getAttendanceStatusById.pending, (state) =>{
        state.loading = true;
        state.error = null;
      })
      .addCase(getAttendanceStatusById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectStatus = action.payload.data;
      })
      .addCase(getAttendanceStatusById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }) 
      
      .addCase(updateStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(updateStatus.fulfilled, (state, action) => {
        state.loading = false;
        // state.attendanceStatus = action.payload.data;
      })

      .addCase(updateStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       .addCase(deleteStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(deleteStatus.fulfilled, (state, action) => {
        state.loading = false;
        // state.attendanceStatus = action.payload.data;
      })

      .addCase(deleteStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      

  },
});

export default statusSlice.reducer;